<template>
    <div id="product__panelists--edit">
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">Date:</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top pa-0 ma-0">
               <DatePicker
  :date="pp_date"
  @choose="chooseDate"
/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0">Invitation Id:</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-text-field  class="ma-0 pa-0"  label="Invitation Id" outlined dense v-model="invitation_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0">Last 4 digits</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-text-field  label="Last 4 digits" outlined dense class="ma-0 pa-0" v-model="tracking_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-btn small color="primary" @click="close()">Close</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from './../../utilities/DatePicker'

export default {
  name: 'EditPanelist',
  components: {
    DatePicker
  },
  props: {
    index: Number,
    entryDate: String  // ✅ properly declared
  },
  data: () => ({
    pp_date: '',
    invitation_id: '',
    tracking_id: '',
  }),
  mounted() {
    const pans = this.$store.getters['ProductData/getPanelists'];
    if (pans && pans.length > this.index) {
      const current_pan = pans[this.index];
      this.pp_date = current_pan.pp_date;
      this.invitation_id = current_pan.invitation_id;
      this.tracking_id = current_pan.tracking_id;
    }
  },
  methods: {
  chooseDate(d) {
    const dateOnly = d.split(/[T ]/)[0];
    const entryDateOnly = this.entryDate?.split(/[T ]/)[0];
    // const ecContentType = this.$route?.query?.ec_content_type;

    // Only validate if ec_content_type is 'direct'
    // if (ecContentType === 'direct' && entryDateOnly && dateOnly !== entryDateOnly) {
    //   this.$swal.fire({
    //     icon: "warning",
    //     position: "bottom-end",
    //     title: "Invalid Date",
    //     text: `Panelist Date must match Entry Date: ${entryDateOnly}`,
    //     confirmButtonText: "OK"
    //   });

    //   return;
    // }
          this.pp_date = entryDateOnly;
    this.pp_date = dateOnly;

    this.$store.dispatch('ProductData/editPanelist', {
      key: 'pp_date',
      val: dateOnly,
      index: this.index
    });

    this.$emit('editDate', dateOnly);
  },

  close() {
    this.$emit('closeEditPanelist', false);
    this.$emit('editDate');
  }

  },
  watch: {
    invitation_id(newVal) {
      this.$store.dispatch('ProductData/editPanelist', {
        key: 'invitation_id',
        val: newVal,
        index: this.index
      });
    },
    tracking_id(newVal) {
      this.$store.dispatch('ProductData/editPanelist', {
        key: 'tracking_id',
        val: newVal,
        index: this.index
      });
    }
  }
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/product'
</style>